export enum TrailerCloseoutModal {
  INVALID_BOL_ID = "INVALID_BOL_ID",
  BOL_NOT_FOUND = "BOL_NOT_FOUND",
  INVALID_BOL = "INVALID_BOL",
  TRAILER_CONFIRMATION = "TRAILER_CONFIRMATION",
  TRAILER_TYPE_SELECTION = "TRAILER_TYPE_SELECTION",
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
}
